import React from "react";
import { Login } from "../../../components";
import { useTranslation } from "react-i18next";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";

export const CorporateBackofficeLogin = () => {
    const { t } = useTranslation();
    return (
        <Login
            title={t("login.corporate-backoffice-login")}
            redirect={`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.LOCATIONS.ROOT}/0`}
        />
    );
};
